import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PublicationCardIdentifiers } from '@/module/Author/Publication/components/PublicationCardIdentifiers';
import { PublicationTitle } from '@/module/Author/Publication/components/PublicationTitle';

import { BdiList, LanguagePill, NoOfAuthors, PublicationPages, PublishedAtText } from '@feature/utils';

import { Book } from './../../model/BookTypes';
import classes from './BookCard.module.css';

export interface BookCardProps {
  book: Book;
  to?: string;
  onClick?: () => void;
}

export function BookCard({ book, to, onClick }: BookCardProps) {
  const {
    publishedAt,
    authors,
    language,
    noOfPages,
    publisher,
    startPage,
    endPage,
    identifiers,
    publisherType,
    bdis,
    type,
  } = book;
  const { t } = useTranslation();

  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      onClick={onClick}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <PublicationTitle publication={book} />
        <Group>
          {publisher && (
            <>
              <Text>
                {publisher.title} {publisherType?.name ? `(${publisherType.name})` : ''}
              </Text>
              <PublicationPages
                startPage={startPage}
                endPage={endPage}
                noOfPages={noOfPages}
              />
            </>
          )}
        </Group>
        <BdiList bdis={bdis} />
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <NoOfAuthors authors={authors} />
        </Group>
        <Group>
          <LanguagePill language={language} />
          {identifiers && <PublicationCardIdentifiers identifiers={identifiers} />}
          <Pill>{t(`books.form.fields.types.${type}`)}</Pill>
        </Group>
      </Stack>
    </Paper>
  );
}
